<div id="sc-chatbot-overlay" #chatbotOverlay>

  <div id="sc-chatbot-container">
    <sc-chatbot-chat-header [chat]="chat" [showHide]="true" (hide)="hide()" [showBack]="false"></sc-chatbot-chat-header>
    <sc-chatbot-stream *ngIf="chat" #chatbotStream [chat]="chat" (onEndOfChat)="handleEndOfChat($event)"></sc-chatbot-stream>
  </div>

</div>

<sc-chatbot-trigger-button #chatbotTrigger [class.d-none]="isActive" class="d-md-block" (click)="toggle()"></sc-chatbot-trigger-button>